export const FEATURE_ID = {
  MQTT: "MQTT",
  API_KEYS: "API_KEYS",
  SYNC_DATA : "SYNC_DATA",
  DATA_SHARING : "DATA_SHARING",
  USER_GUIDE : "USER_GUIDE",
};
